export type { PDFViewerContextType } from './contexts/PDFViewerControlContext';
export { usePDFViewerControlContext } from './contexts/PDFViewerControlContext';
export { PDFViewerControlProvider } from './contexts/PDFViewerControlContext';
export type { PDFViewerSearchContextType } from './contexts/PDFViewerSearch/PDFViewerSearchContext';
export { usePDFViewerSearchContext } from './contexts/PDFViewerSearch/PDFViewerSearchContext';
export type { PDFViewerHandle, PDFViewerProps } from './PDFViewer';
export type { PDFViewerControls } from './PDFViewer';
export { PDFViewer } from './PDFViewer';
export * from './utils/constants';

// Export PDF-related types and utilities
export type { RenderOutlinePageMenu } from './components/PDFViewerOutline/components/PDFViewerOutlinePage/PDFViewerOutlinePage';
export type { PDFCurrentSearchResultElementContextType } from './contexts/PDFCurrentSearchResultElementContext';
export { PDFCurrentSearchResultElementContextProvider } from './contexts/PDFCurrentSearchResultElementContext';
export { usePDFCurrentSearchResultElementContext } from './contexts/PDFCurrentSearchResultElementContext';
export { PDFPagesCache } from './utils/PDFPagesCache';

// Re-export PDF.js types (these come from the pdf.js library)
export type { PDFDocumentProxy } from 'pdfjs-dist';
